export default{
    img(){
        return[
            {
                "title":"商城首页",
                "img":require("../assets/images/main.png"),
                "icon":require("../assets/images/home.png"),
                "hoverImg":require("../assets/images/home_selected.png")
            },
            {
                "title":"活动专区",
                "img":require("../assets/images/activity.png"),
                "icon":require("../assets/images/huodong.png"),
                "hoverImg":require("../assets/images/huodong2.png")
            },
            {
                "title":"用户主页",
                "img":require("../assets/images/mine.png"),
                "icon":require("../assets/images/character.png"),
                "hoverImg":require("../assets/images/user_selectd.png")
            },
            {
                "title":"优惠券",
                "img":require("../assets/images/coupon.png"),
                "icon":require("../assets/images/youhuiquan.png"),
                "hoverImg":require("../assets/images/youhuiquan2.png")
            },
            {
                "title":"购物车",
                "img":require("../assets/images/shopping_cart.png"),
                "icon":require("../assets/images/cart_2.png"),
                "hoverImg":require("../assets/images/cart_sele.png")
            },
            {
                "title":"商品详情",
                "img":require("../assets/images/info.png"),
                "icon":require("../assets/images/shangpin.png"),
                "hoverImg":require("../assets/images/shangpin拷贝.png")
            }
        ]
    }
}